import { render, staticRenderFns } from "./ExamQuestionPreview.vue?vue&type=template&id=f1d87b5c&scoped=true"
import script from "./ExamQuestionPreview.vue?vue&type=script&lang=js"
export * from "./ExamQuestionPreview.vue?vue&type=script&lang=js"
import style0 from "./ExamQuestionPreview.vue?vue&type=style&index=0&id=f1d87b5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d87b5c",
  null
  
)

export default component.exports